module.exports = __webpack_public_path__ + "share-icon-d80580b23660a28777342ba058d44058.png";


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Benefits/share-icon.png
 ** module id = 475
 ** module chunks = 0
 **/